import React, { FC } from "react";
import closeIcon from '../../images/close.svg';
import WizardSideBarStep from "../../models/WizardSideBarStep";
import Card from "../card/card";
import CardBody from "../card/card-body";
import CardHeader from "../card/card-header";
import WizardSideBar from "../wizard-sidebar/wizard-sidebar";

interface NotificationWizardProps {
    onClose: () => void;
    step: number;
    name: string;
    sidebarSteps: WizardSideBarStep[];
    stepContent: JSX.Element[]
}

const NotificationWizard: FC<NotificationWizardProps> = ({ name, onClose, step, sidebarSteps, stepContent }) => {

    return <div className='relative overflow-hidden' style={{ height: 560, width: 890 }} >
        <Card className="h-full flex flex-col">
            <CardHeader className={`flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                <div className="flex flex-row">
                    <p className="pl-3 font-bold font text-white">{name}</p>
                </div>
                <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
            </CardHeader>
            <div className={`flex flex-row h-full overflow-hidden`}>
                <WizardSideBar isExpanded={true} step={step} steps={sidebarSteps}></WizardSideBar>
                <CardBody className={`px-2 h-full w-full`} >
                    {stepContent[step]}
                </CardBody>

            </div>
        </Card>
    </div>

}

export default NotificationWizard;